module.exports = __webpack_public_path__ + "static/media/sectionBg.cf0bcfc5.png";